<script>
    import ProductInformation from "./ProductInformation.svelte";
    import EnergyEfficiency from "./EnergyEfficiency.svelte";
    import ImageTile from "./ImageTile.svelte";
    import clickTracker from "../tracking/clickTracker";
    import Sustainability from "./Sustainability.svelte";
    import BenefitBadge from "./BenefitBadge.svelte";
    import DiscountTag from "./DiscountTag.svelte";
    import { getContext } from "svelte";
    import { key as cinemaTileDimensionCtxKey } from "../context/cinemaTileDimension.js";
    import { key as add2BasketButtonCtxKey } from "../context/add2BasketButton.js";
    import Add2BasketGreyButton from "./Add2BasketGreyButton.svelte";
    import Add2BasketRedButton from "./Add2BasketRedButton.svelte";

    /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */

    /*                */
    let {
        recommendation,
        featuresState = {},
        lazyLoad,
        cinemaTracking,
        featureIndex,
        cinemaIndex,
        cinemaMeta,
        additionalCinemaClickTracking,
        cinemaId,
        additionalNextPiTrackingLabels = null,
        additionalTrackingLabels = null,
        wishlist_class = false,
        showTopInfo = false,
        personalisedUser = false,
    } = $props();

    const tileDimensions = getContext(cinemaTileDimensionCtxKey);
    const add2BasketButton = getContext(add2BasketButtonCtxKey);

    const {
        brandName,
        image,
        deal,
        _embedded: { "o:variation": variation },
        formattedPrice,
        tracking,
        veryPopular,
        minimumOrderValueEligible,
    } = $derived(recommendation);

    const showBottomBenefitBadge = $derived(variation.benefitId && variation.customerBenefitBadge);
    const discountValue = $derived(featuresState.ENABLE_DISCOUNT_TAG_IN_RECOMMENDATION ? variation.discountValue : null);

    const showEnergyEfficiency = $derived(
        Array.isArray(variation.energyEfficiencyClasses) && variation.energyEfficiencyClasses.length >= 1
    );

    const baseDetailViewUrl = $derived(variation._links["o:base-detail-view-url"]?.href);
    const variationDetailViewUrl = $derived(variation._links["o:variation-detail-view-url"]?.href);

    const clickHandler = () => {
        clickTracker(
            cinemaTracking,
            tracking,
            featureIndex,
            cinemaIndex,
            additionalCinemaClickTracking,
            recommendation.additionalClickTracking,
            cinemaMeta,
            recommendation.meta,
            additionalTrackingLabels,
            additionalNextPiTrackingLabels
        );
    };

    const getDataTracking = () => {
        const promoSource = recommendation.tracking?.labels?.promo_Source;
        const promoTypeSuffix = recommendation.tracking?.name?.split("-")[0];

        if (!promoSource || !promoTypeSuffix) {
            return undefined;
        }

        return '{"promo_Source":"' + promoSource + '","promo_Type":"' + `promo_${promoTypeSuffix}` + '"}';
    };

    const GREY = "GREY";
    const RED = "RED";

    const showAdd2BasketButton = (colorOption, buttonColor) => {
        switch (colorOption) {
            case GREY:
                return buttonColor === GREY;
            case RED:
                return buttonColor === RED;
            default:
                return false;
        }
    };
</script>

<div
    style:min-width={`${tileDimensions.minimumWidth}px`}
    class="reco_cinema__tile"
    class:wishlist_class
    data-tracking={getDataTracking()}
    data-tracking-feature-id={tracking?.id}
    data-qa="slidingCinemaPromotion"
    data-testid="recommendation-tile"
>
    <!-- svelte-ignore a11y_no_static_element_interactions -->
    <!-- svelte-ignore a11y_click_events_have_key_events -->
    <oc-link-v2 base64-href={btoa(variationDetailViewUrl)} onclick={clickHandler} data-testid="reco-card">
        <a class="reco_cinema__adslink" href={baseDetailViewUrl}>
            <oc-card-v2>
                <ImageTile
                    {image}
                    {lazyLoad}
                    variationId={variation.id}
                    {deal}
                    isVeryPopular={veryPopular}
                    {featuresState}
                    {personalisedUser}
                />
            </oc-card-v2>
            <ProductInformation {brandName} {variation} pricing={formattedPrice} {showTopInfo} />
        </a>
    </oc-link-v2>

    <div class="reco_cinema__taglist">
        <DiscountTag {discountValue} />
        {#if showBottomBenefitBadge}
            <BenefitBadge benefitDiscountValuePercent={variation.customerBenefitBadge} benefitId={variation.benefitId} />
        {/if}
    </div>
    {#if minimumOrderValueEligible}
        <oc-logo-v1 data-testid="ottoUp_logo" fill-parent class="oc-mt-50 reco_cinema__otto-up-logo" logo="otto-up"></oc-logo-v1>
    {/if}
    {#if showAdd2BasketButton(GREY, add2BasketButton?.buttonColor)}
        <div class="oc-mt-100 oc-mb-150">
            <Add2BasketGreyButton
                variationId={variation.id}
                widgetAdditionalClickTracking={additionalCinemaClickTracking}
                pageName="basket"
            />
        </div>
    {/if}
    {#if showAdd2BasketButton(RED, add2BasketButton?.buttonColor)}
        <div class="oc-mt-100 oc-mb-150">
            <Add2BasketRedButton
                variationId={variation.id}
                widgetAdditionalClickTracking={additionalCinemaClickTracking}
                pageName="basket"
            />
        </div>
    {/if}
    {#if showEnergyEfficiency}
        <div class="oc-mt-50">
            <EnergyEfficiency energyEfficiencyClasses={variation.energyEfficiencyClasses} />
        </div>
    {/if}
    <Sustainability labels={variation.sustainabilities} variationId={variation.id} {cinemaId} {cinemaTracking} />
    {#if featuresState.SHOW_RADIO_EQUIPMENT_REGULATION && variation.radioEquipmentRegulation?.chargingPower}
        <ofc-radio-equipment-regulation-v1
            class="reco_cinema__radio-equipment-regulation"
            size="50"
            min-power={variation.radioEquipmentRegulation.chargingPower?.min}
            max-power={variation.radioEquipmentRegulation.chargingPower?.max}
            chargingDevice={variation.radioEquipmentRegulation?.chargingDeviceIncluded}
            usbPd={variation.radioEquipmentRegulation?.supportsUsbPowerDelivery}
        >
        </ofc-radio-equipment-regulation-v1>
    {/if}
</div>

<style lang="scss">
    .reco_cinema__tile {
        display: flex;
        flex-direction: column;
        margin: 0 8px 0 0;
        vertical-align: top;
        white-space: normal;
        position: relative;
        height: 100%;

        &:last-child {
            margin-right: 0;
        }
    }

    .reco_cinema__radio-equipment-regulation {
        padding-top: 8px;
    }

    .reco_cinema__taglist {
        display: flex;
        flex-wrap: wrap;
    }

    .reco_cinema__adslink {
        color: black;
        text-decoration: none;
        overflow-y: auto;
    }

    .reco_cinema__adslink:hover {
        text-decoration: black underline;
    }

    .reco_cinema__adslink:hover :global(.reco_cinema__price-per-unit) {
        text-decoration: grey underline;
    }

    .reco_cinema__otto-up-logo {
        width: 52px;
        height: 16px;
    }
</style>
